import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

class Organisation_EN extends Component {
    render() {
        const { classes } = this.props;

        return (
            <Fragment>
                <text
                    className={ classes.root }
                    transform="matrix(0.86, -0.51, 0.51, 0.86, 26.23, 15.89)"
                >
                    R
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(31.8 12.7) rotate(-24.72)"
                >
                    i
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(34.09 11.6) rotate(-20.16)"
                >
                    s
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(38.16 10.07) rotate(-13.76)"
                >
                    k
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(43.3 8.82) rotate(-7.43)"
                >
                    -
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(47.68 8.22) rotate(-1.18)"
                >
                    a
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(52.84 8.11) rotate(5.39)"
                >
                    v
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(57.83 8.56) rotate(12.19)"
                >
                    e
                </text>,

                <text
                    className={ classes.root }
                    transform="translate(63.06 9.72) rotate(18.21)"
                >
                    r
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(66.66 10.89) rotate(23.59)"
                >
                    s
                </text>,
                <text
                    className={ classes.root }
                    transform="matrix(0.87, 0.5, -0.5, 0.87, 70.67, 12.6)"
                >
                    e
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(90.09 32.3) rotate(66.29)"
                >
                    I
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(91.34 34.95) rotate(72.15)"
                >
                    n
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(93.11 40.65) rotate(78.28)"
                >
                    f
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(93.87 43.87) rotate(84.43)"
                >
                    o
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(94.4 49.93) rotate(90.79)"
                >
                    r
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(94.55 53.66) rotate(99)"
                >
                    m
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(93.03 62.4) rotate(108.21)"
                >
                    a
                </text>,
                <text
                    className={ classes.root }
                    transform="matrix(-0.4, 0.92, -0.92, -0.4, 91.36, 67.31)"
                >
                    l
                </text>,
                <text
                    className={ classes.root }
                    transform="matrix(-0.52, -0.85, 0.85, -0.52, 16.54, 77.3)"
                >
                    H
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(12.75 70.87) rotate(-114.9)"
                >
                    i
                </text>,
                <text
                    className={ classes.root }
                    transform="matrix(-0.34, -0.94, 0.94, -0.34, 11.62, 68.6)"
                >
                    e
                </text>,

                <text
                    className={ classes.root }
                    transform="translate(9.85 63.55) rotate(-103.67)"
                >
                    r
                </text>,
                <text
                    className={ classes.root }
                    transform="matrix(-0.14, -0.99, 0.99, -0.14, 8.92, 59.9)"
                >
                    a
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(8.24 54.76) rotate(-91.95)"
                >
                    r
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(8.07 50.98) rotate(-86.1)"
                >
                    c
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(8.39 45.75) rotate(-78.8)"
                >
                    h
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(9.63 39.89) rotate(-73.16)"
                >
                    i
                </text>,
                <text
                    className={ classes.root }
                    transform="matrix(0.37, -0.93, 0.93, 0.37, 10.29, 37.44)"
                >
                    c
                </text>,
                <text
                    className={ classes.root }
                    transform="matrix(0.48, -0.88, 0.88, 0.48, 12.26, 32.56)"
                >
                    a
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(14.82 28.03) rotate(-55.95)"
                >
                    l
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(29.96 95.23) rotate(21.83)"
                >
                    D
                </text>,
                <text
                    className={ classes.root }
                    transform="matrix(0.97, 0.23, -0.23, 0.97, 37.4, 98.08)"
                >
                    y
                </text>,
                <text
                    className={ classes.root }
                    transform="matrix(0.99, 0.11, -0.11, 0.99, 42.99, 99.42)"
                >
                    n
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(49.62 100.08) rotate(-1.2)"
                >
                    a
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(55.66 100.05) rotate(-10.58)"
                >
                    m
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(65.11 98.03) rotate(-18.3)"
                >
                    i
                </text>,
                <text
                    className={ classes.root }
                    transform="translate(68.03 97.11) rotate(-23.63)"
                >
                    c
                </text>
            </Fragment>
        );
    }
}
export default Organisation_EN;

Organisation_EN.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.string
    })
};

Organisation_EN.defaultProps = {
    classes: {}
};
